var _defs, _path, _path2, _line, _line2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _polyline, _path10, _path11, _polyline2, _path12, _line3, _line4, _path13, _path14, _polyline3, _polyline4, _polyline5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLifestyleSliderBackpainIconWhite5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113.39 113.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-backpain-slider-white{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-backpain-slider-white",
    d: "M20.59,76s6.5,1.56,15.78,7.19S52.12,93.31,52.12,93.31h4.57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-backpain-slider-white",
    d: "M92.2,76s-6.5,1.56-15.78,7.19S60.67,93.31,60.67,93.31H56.1"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1-backpain-slider-white",
    x1: 51.56,
    y1: 94.53,
    x2: 49.59,
    y2: 102.97
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1-backpain-slider-white",
    x1: 60.59,
    y1: 94.53,
    x2: 62.56,
    y2: 102.97
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-backpain-slider-white",
    d: "M87.44,64.34c4.22,6.75,5.91,11.54,6.19,17.16s0,19.13,0,19.13"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-backpain-slider-white",
    d: "M83.51,21.31a37,37,0,0,0-4.79,18.23,22.27,22.27,0,0,0,1,7.29"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-backpain-slider-white",
    d: "M26,64.34c-4.22,6.75-5.91,11.54-6.19,17.16s0,19.13,0,19.13"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-backpain-slider-white",
    d: "M29.91,21.31s5.06,8,4.78,17.56a20.73,20.73,0,0,1-1,7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-backpain-slider-white",
    d: "M20.59,76s6.5,1.56,15.78,7.19S52.12,93.31,52.12,93.31h4.57"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-backpain-slider-white",
    d: "M92.2,76s-6.5,1.56-15.78,7.19S60.67,93.31,60.67,93.31H56.1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-backpain-slider-white",
    d: "M87.15,51.62a9.39,9.39,0,0,1,.55,4.78c-.33,2.8.46,5.58-1.64,5.33-1.22-.14-2-4-2.55-5.33-2.82,2.65-7,7.23-9.36,5.69a7.55,7.55,0,0,1-2-10.67c2-2.83,7.21-5.3,9.76-5.46"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-backpain-slider-white",
    points: "82.34 15.94 95.36 23.54 82.89 46.09"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-backpain-slider-white",
    d: "M90.56,7.2l8.1,5.44s6,5.2,6.35,6.68a29.79,29.79,0,0,1,0,5.8L88.72,51.68"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-backpain-slider-white",
    d: "M26.79,51.62a9.59,9.59,0,0,0-.54,4.78c.33,2.8-.46,5.58,1.63,5.33,1.23-.14,2-4,2.56-5.33,2.82,2.65,7,7.23,9.35,5.69a7.54,7.54,0,0,0,2-10.67c-2-2.83-7.21-5.3-9.75-5.46"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-backpain-slider-white",
    points: "31.61 15.94 18.59 23.54 31.05 46.09"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-backpain-slider-white",
    d: "M23.38,7.2l-8.09,5.44s-6,5.2-6.35,6.68a29,29,0,0,0,0,5.8L25.23,51.68"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1-backpain-slider-white",
    x1: 51.56,
    y1: 94.53,
    x2: 49.59,
    y2: 102.97
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1-backpain-slider-white",
    x1: 60.59,
    y1: 94.53,
    x2: 62.56,
    y2: 102.97
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-backpain-slider-white",
    d: "M87.05,64.54c2.9,5.78,6.4,13.43,6.58,17,.28,5.63,0,19.13,0,19.13"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-backpain-slider-white",
    d: "M26,64.34s23,3,30.72,3c10.62,0,22.14-2.16,25.72-2.5"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-backpain-slider-white",
    points: "63.32 55.28 61.61 45.75 72.17 45.61 68.96 37.27"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-backpain-slider-white",
    points: "56.75 43.56 55.35 38.26 61.3 37.7 59.11 33.14"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-backpain-slider-white",
    points: "48.37 55.87 51.96 47.22 41.27 45.68 46.15 38.35"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifestyleSliderBackpainIconWhite5);
export default __webpack_public_path__ + "static/media/lifestyle_slider_backpain_icon_white_5.cac507c9.svg";
export { ForwardRef as ReactComponent };